import "./Projects.css";

// Import images from src/img folder
import residentialImg from "../../img/project1.jpeg";
import officeImg from "../../img/project2.jpeg";

import warehouseImg from "../../img/project3.jpeg";
import warehouseImg1 from "../../img/project4.jpeg";
import residentialImg1 from '../../img/project5.jpeg';
import residentialImg2 from '../../img/project6.jpeg';
import storage from '../../img/storage.jpeg';
import factory from "../../img/factory.jpeg";
import resident from "../../img/resident.jpeg";

function Projects() {
  const projects = [
    {
      image: residentialImg,
      title: "Residential Building",
      description: "A modern apartment complex with eco-friendly design."
    },
    {
      image: officeImg,
      title: "Corporate Office ",
      description: "High-rise office building with smart workspace solutions."
    },
    
   
    {
      image: warehouseImg1,
      title: "Industrial Warehouse",
      description: "Spacious warehouse facility with cutting-edge safety measures."
    },
    {
  image: residentialImg1,
  title: "Residential Building",
  description: "Contemporary living spaces designed for comfort, style, and sustainability."
},
{
  image: residentialImg2,
  title: "Residential Building",
  description: "Spacious homes crafted with innovative design and a focus on sustainable living."
},
{
  image: warehouseImg,
  title: "Industrial Warehouse",
  description: "High-capacity storage facility built for efficiency, security, and modern operations."
},
{
  image:storage,
  title:"Storage Warehouse",
  description:"A secure and well-organized facility designed for efficient storage and handling of materials."
},
{
  image:factory,
  title: "Production Plant",
  description: "Modern production facility built to deliver efficiency, safety and consistent output."
},
{
  image: resident,
  title: "Residential Building",
  description: "Spacious homes crafted with innovative design and a focus on sustainable living."
}





  
  ];

  return (
    <div className="projects-page">
      <header className="projects-header">
        <h1>Our Projects</h1>
        <p>
          A showcase of our completed works across residential, commercial, and
          industrial sectors.
        </p>
      </header>

      <div className="projects-container">
        {projects.map((project, index) => (
          <div className="project-card" key={index}>
            <img src={project.image} alt={project.title} />
            <div className="project-content">
              <h3>{project.title}</h3>
              <p>{project.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Projects;

